import Uppload from "uppload";
import { GT_HOSTNAME } from "../../../../constants/settings";
import axios from "axios";
export default {
  name: "uppload-btn",
  render() {
    return this.$scopedSlots.default({
      on: (event) => {
        const contentImage = new Uppload({
          // Default file value, useful for empty-state images
          value: "https://via.placeholder.com/600x400.png?text=Content%20Image",
          endpoint: {
            url: `${GT_HOSTNAME}contents/upload_image?save_file=test.jpg`,
          },

          // Maximum file size allowed in bytes (this is 25 MB)
          maxFileSize: 25000000,

          // Types of files to allow (string or MIME type array)
          allowedTypes: "image",
          crop: {
            minSize: [64, 64, "px"],
            startSize: [100, 100, "%"],
          },
          uploadFunction: (file, metadata) => {
            const data = new FormData();
            data.append("image", file);
            data.append("meta", JSON.stringify(metadata));
            return axios
              .post(`${GT_HOSTNAME}content/upload_img`, data, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then(function (response) {
                return response.data;
              })
              .catch(function (error) {
                console.log("ERROR", error);
              });
          },
        });
        contentImage.on("fileUploaded", (payload) => {
          this.$emit("uploadComplete", payload);
        });
        contentImage.openModal();
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/shared/contents/UpploadBtn.js